// extracted by mini-css-extract-plugin
module.exports = {"headBg":"PortaleValorizzazioniTemplate_headBg__y4bc6","portaleValorizzazioniContent":"PortaleValorizzazioniTemplate_portaleValorizzazioniContent__s1otM"};